<div class="kt-portlet">
    <div class="kt-portlet__head kt-portlet__head__custom">
        <div class="kt-portlet__head-label">
            <h3 class="kt-portlet__head-title">
                NAKLİYE TEKLİF FORMU
            </h3>
        </div>
    </div>
    <div class="kt-portlet__body" *ngIf="bidInfo$ | async as bid">

      

        <ng-container *ngIf="!(formEnd$ | async)">

            <!-- Ihale "Acık" durumda ise, ihale bilgileri goruntulenir. -->
            <ng-container *ngIf="bid.ihaleDurum == 1">

                <div class="alert alert-info fade show text-center offerForm" role="alert">
                    <div class="alert-icon"><i class="flaticon-warning"></i></div>
                    <div class="alert-text">Merhaba {{bid.ilgiliFirmaYetkili}}, <br>Aşağıdaki nakliye bilgilerine
                        istinaden teklif vermenizi rica ederiz.</div>
                </div>
                <div class="kt-form kt-form--label-right offerForm">
                    <div class="form-group kt-form__group row">

                        <label class="col-lg-3 col-4 col-sm-3 offset-sm-3 offset-lg-3 col-form-label text-right">Teklif No:</label>
                        <div class="col-lg-4 col-7 col-sm-4 text-left">
                            <label class="col-form-label"><strong>{{bid.name}}</strong></label>
                        </div>
                    </div>
                    <div class="form-group kt-form__group row">

                        <label class="col-lg-3 col-4 col-sm-3 offset-sm-3 offset-lg-3 col-form-label text-right">Yükleme Tarihi:</label>
                        <div class="col-lg-4 col-7 col-sm-4 text-left">
                            <label
                                class="col-form-label text-left"><strong>{{bid.yuklemeTarihi | date : 'dd MMMM yyyy'}}</strong></label>
                        </div>
                    </div>
                    <div class="form-group kt-form__group row">

                        <label class="col-lg-3 col-4 col-sm-3 offset-sm-3 offset-lg-3 col-form-label text-right">Araç Cinsi:</label>
                        <div class="col-lg-4 col-7 col-sm-4 text-left">
                            <label class="col-form-label text-left"><strong>{{bid.aracCinsi}}</strong></label>
                        </div>
                    </div>
                    <div class="form-group kt-form__group row">

                        <label class="col-lg-3 col-4 col-sm-3 offset-sm-3 offset-lg-3 col-form-label text-right">Yükleme Yeri:</label>
                        <div class="col-lg-4 col-7 col-sm-4 text-left">
                            <label class="col-form-label text-left"><strong>{{bid.yuklemeYeri}}</strong></label>
                        </div>
                    </div>
                    <div class="form-group kt-form__group row">

                        <label class="col-lg-3 col-4 col-sm-3 offset-sm-3 offset-lg-3 col-form-label text-right">Boşaltma Yeri:</label>
                        <div class="col-lg-4 col-7 col-sm-4 text-left">
                            <label class="col-form-label text-left"><strong>{{bid.bosaltmaYeri}}</strong></label>
                        </div>
                    </div>
                    <div class="form-group kt-form__group row">

                        <label class="col-lg-3 col-4 col-sm-3 offset-sm-3 offset-lg-3 col-form-label text-right">Tonaj:</label>
                        <div class="col-lg-4 col-7 col-sm-4 text-left">
                            <label class="col-form-label text-left"><strong>{{bid.tonajCinsi}}</strong></label>
                        </div>
                    </div>
                    <!-- <div class="form-group kt-form__group row">

				<label class="col-lg-3 offset-lg-3 col-form-label">Tonaj Birim:</label>
				<div class="col-lg-3">
					<label class="col-form-label text-left">{{bid.tonajBirim}}</label>
				</div>
			</div> -->
                    <div class="form-group kt-form__group row">

                        <label class="col-lg-3 col-4 col-sm-3 offset-sm-3 offset-lg-3 col-form-label text-right">Kapasite:</label>
                        <div class="col-lg-4 col-7 col-sm-4 text-left">
                            <label class="col-form-label text-left"><strong>{{bid.kapasite}}
                                    {{bid.tonajBirim}}</strong></label>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-lg-3 offset-lg-3 col-form-label">Teklif Tutarını Yazınız (TL)</label>
                        <div class="col-lg-3 col-sm-4 offset-sm-4">
                            <input type="number" class="form-control" [(ngModel)]="price">
                        </div>
                    </div>


                    <div class="row">
                        <div class="col-lg-12 text-center kt-margin-b-20">
                            <button (click)="onSubmit(0)" class="btn btn-warning kt-margin-r-10">İlgilenmiyorum</button>

                            <button (click)="onSubmit(1)" class="btn btn-success kt-margin-l-10">Teklifi Gönder</button>
                        </div>
                    </div>

                </div>
            </ng-container>


            <!-- İhale "Acik" durumda degilse, ihalenin sona erdigine dair bir mesaj goruntulenir. -->
            <ng-container *ngIf="bid.ihaleDurum != 1">
                <div class="alert alert-info fade show text-center offerForm" role="alert">
                    <div class="alert-icon"><i class="flaticon-warning"></i></div>
                    <div class="alert-text">Teklif süreci sona ermiştir!</div>
                </div>
            </ng-container>
        </ng-container>


        <ng-container *ngIf="formEnd$ | async">
            <h5>Teşekkür ederiz!</h5>
        </ng-container>

    </div>
</div>
<!--<div class="col-md-12 kt-margin-bottom-10-mobile">
			<label class="kt-checkbox kt-checkbox--bold kt-checkbox--brand">
				<input type="checkbox" name="checkbox1">

				<span></span>
			</label>
		</div>-->
